import { getDefaultSaveState, ISavesManager, ISaveState } from '@core/saves/saves.interface';
import { Observable, Subject } from 'rxjs';
import { Leerkr8Objective } from '@core/saves/leerkr8/types';

export class NoopSaverService implements ISavesManager {
  private onLoginSubject = new Subject<string>();
  onLogin$: Observable<string> = this.onLoginSubject.asObservable();

  addPlaythroughObjective(objectives: Leerkr8Objective): void {}

  async startPolling(): Promise<void> {}

  async stopPolling(): Promise<void> {}

  async save(state: Partial<ISaveState>): Promise<void> {
    return;
  }

  async load(): Promise<ISaveState> {
    return getDefaultSaveState();
  }

  async login(playerCode: string): Promise<void> {
    this.onLoginSubject.next(playerCode);
    return;
  }

  isLoggedIn(): boolean {
    return true;
  }

  logout(): void {
    return;
  }
}
